import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Toast, useShowTime } from 'common-package';
import { Device } from '@capacitor/device';
import lookie from 'lookie';
import { PasscodeInput } from 'antd-mobile';
import { selectedDeviceUuid, setStoreInfo } from '@/store/device';
// import { LogoHeader } from '@/components';
import { useNav } from '@/hooks';
import useLogin from '@/hooks/useLogin';
import service from '@/service';
import { CURRENT_ANDROID_ID, UPPER_STATUS_CODE } from '@/constant';
import cx from './index.module.scss';

interface Props {}

const DeviceBinding: React.FC<Props> = () => {
  const nav = useNav();
  const time = useShowTime('星期dd&HH:mm');
  const deviceUuid = useSelector(selectedDeviceUuid);
  const [isError, setIsError] = useState(false);
  const isValidating = useRef(false);
  const { handleLogin } = useLogin();
  const [verifySuccess, setVerifySuccess] = useState<boolean>(false);
  const dispatch = useDispatch();
  const [codeValue, setCodeValue] = useState('');

  // 检测当前门店是否已经绑定
  const checkIsAlreadyBinded = useCallback(async () => {
    const androidId = lookie.get(CURRENT_ANDROID_ID);
    const { data } = await service.system.getBoundStore(androidId);
    if (data?.storeId) {
      nav('/');
    }
  }, [nav]);

  const onTextFill = async (text: string) => {
    Toast.loading('正在校验');
    // checkIsApp() && Keyboard.hide();
    isValidating.current = true;

    try {
      const deviceInfo = await Device.getInfo();
      const { data } = await service.system.bindStore({
        password: text,
        deviceInfo: {
          androidId: deviceUuid,
          ...deviceInfo,
        },
      });
      dispatch(setStoreInfo(data));
      await handleLogin();
      setVerifySuccess(true);
      Toast.success('验证码验证通过');
      nav('/');
    } catch (e) {
      if (e.code === UPPER_STATUS_CODE.NOT_VALID_PASSWORD) {
        setIsError(true);
        // checkIsApp() && Keyboard.show();
        Toast.failIconCode('验证码验证失败');
      }
    } finally {
      isValidating.current = false;
    }
  };

  useEffect(() => {
    checkIsAlreadyBinded();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className={cx('device-binding')}>
      <div className={cx('time-text')}>
        <div className={cx('week')}>{time?.split('&')[0]}</div>
        <div className={cx('line')}>|</div>
        <div className={cx('minute')}>{time?.split('&')[1]}</div>
      </div>
      <div className={cx('wrapper')}>
        <div className={cx('content')}>
          <div className={cx('tip-text')}>
            <div>请输入门店验证码</div>
            <div className={cx('sub-tip')}>如果没有验证码请联系客服</div>
          </div>
          <div
            className={cx(
              'verify-code-box',
              { 'verify-code-box-finish': !verifySuccess && codeValue?.length === 6 },
              { 'verify-code-box-success': verifySuccess },
              { 'verify-code-box-error': isError && codeValue?.length === 6 }
            )}>
            <PasscodeInput
              seperated={true}
              value={codeValue}
              plain={true}
              onChange={text => {
                if (isValidating.current) return;
                setIsError(false);
                setCodeValue(text);
              }}
              length={6}
              error={isError}
              onFill={onTextFill}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeviceBinding;
